import React from "react";

import "./MaintenancePage.scss";
import { maintenanceConfig } from "../../constants/maintenance.config";
import { useDocumentTitle } from "../../hooks";
import appLogo from "../../resources/images/Logo_CLPLogo-Hor-Blue-03.jpg";

export const MaintenancePage = () => {
  useDocumentTitle("Maintenance");

  const { title, message, estimatedTime, contact } = maintenanceConfig;

  return (
    <section className="maintenance-page">
      <div className="maintenance-page__card">
        <div className="maintenance-page__logo">
          <img
            src={appLogo}
            alt="Crew Logistics Portal"
            className="maintenance-page__logo-img"
          />
        </div>
        <h1 className="maintenance-page__title">{title}</h1>
        <p className="maintenance-page__message">{message}</p>
        {estimatedTime && (
          <p className="maintenance-page__estimated">
            Estimated completion: {estimatedTime}
          </p>
        )}
        {contact && (
          <p className="maintenance-page__contact">
            Questions? {contact}
          </p>
        )}
      </div>
    </section>
  );
};
